import { api } from "./configs/axiosConfigs"
import { defineCancelApiObject } from "./configs/axiosUtils"

export const ProductionLineAPI = {

  index: async function (cancel = false) {
    const response = await api.request({
      url: "/production-lines",
      method: "GET",
      signal: cancel ? cancelApiObject[this.index.name].handleRequestCancellation().signal : undefined,
    })

    return response.data
  },


  store: async function (data, cancel = false) {
    const response = await api.request({
      url: "/production-lines",
      method: "POST",
      data: data,
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  show: async function (production_line, cancel = false) {
    const response = await api.request({
      url: "/production-lines/" + production_line,
      method: "GET",
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  update: async function (production_line, data, cancel = false) {
    const response = await api.request({
      url: "/production-lines/" + production_line,
      method: "PUT",
      data: data,
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  delete: async function (production_line, cancel = false) {
    const response = await api.request({
      url: "/production-lines/" + production_line,
      method: "DELETE",
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

}



// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelApiObject(ProductionLineAPI)